/* unplugin-vue-components disabled */import script from "./TermsAndConditionsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndConditionsModal.vue?vue&type=script&setup=true&lang=js"

import "./TermsAndConditionsModal.vue?vue&type=style&index=0&id=75ebae4c&lang=scss"

const __exports__ = script;

export default __exports__